import Text, { TextType } from './Text';
export { TextType };
export default Text;
